import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class TopicService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/topics/', params);
	}

	async getAllMe(params) {
		return this.api.get('/secure/topics/me', params);
	}

	async getPreference(params) {
		return this.api.get('/secure/topics-preference', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/topic/{id}', { id: id }), params);
	}

	async getRequestById(id, params) {
		return this.api.get(urlReplace('/secure/topic/{id}/request', { id: id }), params);
	}

	//post put delete

	async updatePreference(data, params) {
		return this.api.put('/secure/topics-preference', data, params);
	}
}